module.exports = __webpack_public_path__ + "img/client-search-with-sircle.2ca8e4db.png";